import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "./assets/css/main.css";
import i18n from "./i18n";
import VueTheMask from "vue-the-mask";
import "./plugins/toast";

Vue.use(VueTheMask);
Vue.config.productionTip = false;

Vue.mixin({
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
